/** 判断一日一次 */
export const dailyStorge = storageName => {
  const { localStorage } = window
  const strorageData = localStorage.getItem(storageName) || ''
  const curTimeDate = new Date().toLocaleDateString()
  if (!strorageData) {
    const timeDate = new Date().toLocaleDateString()
    localStorage.setItem(storageName, timeDate)
    return true
  } else if (curTimeDate !== strorageData) {
    localStorage.setItem(storageName, curTimeDate)
    return true
  }
  return false
}

// 获取当前时间戳 秒级
// export const TimeCurrent = parseInt(new Date().getTime() / 1000)
// const t = '2021-8-15 0:0:0' // 月、日、时、分、秒如果不满两位数可不带0.
// const T = new Date(t) // 将指定日期转换为标准日期格式。Fri Dec 08 2017 20:05:30 GMT+0800 (中国标准时间)
// export const DeadLineTime = T.getTime()

export const isOffline = (t, curTime) => {
  const _t = t || '2021-8-15 0:0:0'
  const DeadLineTime = new Date(_t.replace(/-/g, '/')).getTime()
  const TimeCurrent = curTime * 1000 || new Date().getTime() * 1000
  return TimeCurrent >= DeadLineTime
}
